import React, { useContext, useEffect, useState } from 'react'
import LoginForm from './loginForm';
import RegistrationForm from './registrationForm';
import ForgotPassword from './forgotPassword';
import TypeEmail from './typeEmail';
import axios from 'axios';
import { UserContext } from '../../App';
import { LoadingOverlay } from '../loading';
import VerifyEmail from './verifyEmail';
import { useNewBook } from '../dashboard/newBook/functions/useNewBook';

const AllForms = ({ address, setAddress, goToNextStep, handleBuy }) => {

  const { setAuth, user, setUser } = useContext(UserContext)
  const [screen, setScreen] = useState()
  const [first_name, setFirst_Name] = useState('');
  const [last_name, setLast_Name] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [date, setDate] = useState();
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setFirst_Name('')
    setLast_Name('')
    setPassword('')
    setDay('')
    setMonth('')
    setYear('')
    setDate('')
    setErrorMessage('')
    if (setAddress) {
      window.scrollTo({top: 0, behavior: 'auto'})
    }
  }, [screen])

  const checkEmail = () => {
    if (email !== '') {
      setIsLoading(true)
      axios({
        method: 'post',
        url: '/api/checkEmail',
        data: {
            'email': email
        }
      }).then(res => {
        setIsLoading(false)
        if (res.data.emailExist) {
          setScreen(1)
        } else {
          setScreen(2)
        }
      }).catch(error => {
        console.log(error)
      })
    } else {
      setErrorMessage('Indtast venligst din email')
    }
  }

  const handleRegistration = async () => {
      if (first_name !== '' && last_name !== '' && email !== '' && typeof date !== 'undefined' && day !== '' && month !== '' && year !== '' && password !== '') {
        setErrorMessage('')
        setIsLoading(true)
        try {
            const response = await axios.post('/api/register', {
                first_name,
                last_name,
                email,
                'dob': date,
                password,
                address
            });
    
            // Registration successful
            setSuccessMessage('Registration successful!');
            setErrorMessage('');
            setAuth(true)
            setUser(response.data.user)
            localStorage.setItem('token', response.data.token);

            if (typeof handleBuy !== 'undefined') {
              await handleBuy(response.data.user)
              return;
            }
            
            // Clear the form inputs
            setFirst_Name('');
            setLast_Name('');
            setEmail('');
            setPassword('');

            setIsLoading(false)
        } catch (error) {
            // Registration failed
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred during registration');
            }
            setSuccessMessage('');
            setIsLoading(false)
        }
      } else {
        setErrorMessage('Udfyld venligst alle felter')
      }
  }
  
  const handleLogin = async () => {
    if (email !== '' && password !== '') {
      setErrorMessage('')
      setIsLoading(true)
      try {
        const response = await axios.post('/api/login', {
          email,
          password,
          address
        });

        // Registration successful
        setSuccessMessage('Login successful!');
        setErrorMessage('');
        setAuth(true)
        setUser(response.data.user)
        localStorage.setItem('token', response.data.token);

        if (typeof handleBuy !== 'undefined') {
          await handleBuy(response.data.user)
          return;
        }
        
        // Clear the form inputs
        setEmail('');
        setPassword('');

        if (setAddress && typeof address === 'undefined' && 'address' in response.data.user) {
          setAddress(response.data.user.address)
        }

        if (goToNextStep) {
          goToNextStep(response.data.user)
        }
        setIsLoading(false)
      } catch (error) {
        // Registration failed
        if (error.response && error.response.data && error.response.data.message) {
          setErrorMessage(error.response.data.message);
        } else {
          setErrorMessage('Forkert email eller adgangskode');
        }
        setSuccessMessage('');
        setIsLoading(false)
      }
    } else {
        setErrorMessage('Udfyld venligst alle felter')
    }
  }

  return (
    <>
      {(isLoading) ?
        <LoadingOverlay />
      :
          ""}
      {typeof user !== 'undefined' && !user.verified && typeof handleBuy === 'undefined' ?
        <VerifyEmail goToNextStep={goToNextStep} />
      : typeof screen === 'undefined' ?
        <TypeEmail email={email} setEmail={setEmail} errorMessage={errorMessage} setErrorMessage={setErrorMessage} checkEmail={checkEmail} />
      : screen === 1 ?
        <LoginForm setScreen={setScreen} email={email} setEmail={setEmail} password={password} setPassword={setPassword} handleLogin={handleLogin} errorMessage={errorMessage} />
      : screen === 2 ?
        <RegistrationForm setScreen={setScreen} email={email} setEmail={setEmail} password={password} setPassword={setPassword} first_name={first_name} setFirst_Name={setFirst_Name} last_name={last_name} setLast_Name={setLast_Name} day={day} setDay={setDay} month={month} setMonth={setMonth} year={year} setYear={setYear} date={date} setDate={setDate} errorMessage={errorMessage} handleRegistration={handleRegistration} />
      :
        <ForgotPassword setScreen={setScreen} email={email} setEmail={setEmail} errorMessage={errorMessage} setErrorMessage={setErrorMessage} checkEmail={checkEmail} />}
    </>
  )
}

export default AllForms
